import { Tooltip } from '@chakra-ui/react';

type CircleProps = React.SVGProps<SVGCircleElement> & {
	tooltip?: string;
};

export const Circle = (props: CircleProps): React.ReactElement => {
	if (props?.tooltip) return <Tooltip label={props.tooltip}><circle {...props}/></Tooltip>;

	return <circle {...props}/>
};
